import { useState } from 'react'

interface StarRatingProps {
	readonly maxRating?: number | undefined;
	readonly onRating?: ((rating: number) => void) | undefined;
	readonly selectedRating?: number | undefined;
	readonly id?: string | undefined;
	readonly setId?: ((id: string) => void) | undefined;
}

function StarRating({ maxRating = 5, onRating, selectedRating, id, setId }: StarRatingProps) {
	const [hoverRating, setHoverRating] = useState<number | undefined>(undefined)

	return (
		<div className="flex justify-center gap-2 mt-1">
			{ Array.from({ length: maxRating }, (_, i) => i + 1).map(rating => (
				<button
					key={ rating }
					className={ `text-xl transition-colors ${
						(hoverRating && rating <= hoverRating) || (selectedRating && rating <= selectedRating)
							? 'text-yellow-400'
							: 'text-gray-300 hover:text-yellow-400'
					}` }
					onMouseEnter={ () => {
						setHoverRating(rating)
					} }
					onMouseLeave={ () => {
						setHoverRating(undefined)
					} }
					onClick={ () => {
						if (id) {
							setId?.(id)
						}

						onRating?.(rating)
					} }
				>
				★
				</button>
			)) }
		</div>
	)
}

export default StarRating
